import React, { useState } from 'react'
import Popup from '../../../../uicomponents/popup'
import Tab from '../../../../uicomponents/tab'
import withTabGroup from '../../../../hocs/withTabGroup'

/*
 * Read-only counterpart to the builder's FAQ popup. Same container: Popup at
 * size lg, the language TabGroup inside the heading, stickyHeader. Everything
 * that writes is gone - no inputs, no reorder arrows, no add or delete, no
 * submit, no CSV upload or download.
 */

const TabGroup = withTabGroup(Tab, 'group')

const SnapshotFaqs = ({ show, closePopup, scripts }) => {
    //Only languages that actually carry FAQs in this snapshot.
    const withFaqs = (scripts || []).filter(script => script.faqs && script.faqs.length > 0)
    const languagesList = withFaqs.map(script => script.scriptLanguage)

    const [activeLanguage, setActiveLanguage] = useState(languagesList[0] || '')

    const active = withFaqs.find(script => script.scriptLanguage === activeLanguage)
    const faqs = (active && active.faqs) || []

    return (
        <Popup
            show={show}
            closePopup={closePopup}
            size='lg'
            stickyHeader={true}
            heading={
                <div>
                    <div>FAQ's</div>
                    <div style={{ fontSize: '16px' }}>
                        <TabGroup tabs={languagesList} color={'navy-blue-tab-bottom-border'}
                            onClick={(value) => setActiveLanguage(value)}
                            activeTab={activeLanguage}
                        />
                    </div>
                </div>
            }
        >
            <div className='faq_wrapper snapshot-readonly'>
                {faqs.length === 0
                    ? <p className="snapshot-readonly-empty">No FAQs in this snapshot.</p>
                    : faqs.map((faq, index) => (
                        <div className='container_wrapper' key={index}>
                            <div className='template_form'>
                                <div className='snapshot-faq-question'>
                                    <label>Question {index + 1}</label>
                                    <div className='readonly-field'>{faq.question}</div>
                                </div>
                                <div className='snapshot-faq-question'>
                                    <label>Answer</label>
                                    <div className='readonly-field'>{faq.answer}</div>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
        </Popup>
    )
}

export default SnapshotFaqs
